module.exports = __webpack_public_path__ + "static/media/CreateKPITableImage.971557a4.png";